import ClientButton from './ClientButton';

const  ClientContainer = ({ clientsList }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const pastSevenDays = new Date(today);
    pastSevenDays.setDate(today.getDate() - 7);

    const parseDatabaseDate = dateString => {
        const [datePart] = dateString.split(' ');
        const [year, month, day] = datePart.split('-').map(Number);
        return new Date(year, month - 1, day);
    };

    
    const todayClients = clientsList.filter(client => parseDatabaseDate(client.created_at) >= today);
    const pastSevenDaysClients = clientsList.filter(client => parseDatabaseDate(client.created_at) >= pastSevenDays && parseDatabaseDate(client.created_at) < today);
    const remainingClients = clientsList.filter(client => parseDatabaseDate(client.created_at) < pastSevenDays);
    return (
      <div className='client-list'>
        {todayClients.length > 0 && (
          <div>
            <p className='mb-1 text-[#667085] font-medium'>Today</p>
            {todayClients.map((client, index) => (
              <ClientButton
                showFilterBtn = {client.chat_intelligence_key ? true : false}
                filtersObj = {client.chat_intelligence_key}
                displayToolTip = {client.tooltip} 
                key={index} 
                clientName={client.name}
                clientId={client.id}
              />
            ))}
          </div>
        )}
  
        {pastSevenDaysClients.length > 0 && (
          <div className='mt-4'>
            <p className='mb-1 text-[#667085] font-medium'>Previous 7 Days</p>
            {pastSevenDaysClients.map((client, index) => (
              <ClientButton 
                showFilterBtn = {client.chat_intelligence_key ? true : false}
                filtersObj = {client.chat_intelligence_key}
                displayToolTip = {client.tooltip}
                key={index} 
                active={false}
                clientName={client.name}
                clientId={client.id}
               />
            ))}
          </div>
        )}
  
        {remainingClients.length > 0 && (
          <div>
            <p className='mb-1 text-[#667085] font-medium'>Older</p>
            {remainingClients.map((client, index) => (
             <ClientButton 
                showFilterBtn = {client.chat_intelligence_key ? true : false}
                filtersObj = {client.chat_intelligence_key}
                displayToolTip = {client.tooltip}
                key={index} 
                active={false}
                clientName={client.name}
                clientId={client.id}
             />
            ))}
          </div>
        )}
      </div>
    );
  }
  
  export default ClientContainer;